import { MainMemberConsent } from './membersFormType';
import type { PhoneNumberValue } from '../src/client/lib/phoneValidation';

export enum PickupType {
  Office = 'Office',
  Mail = 'Mail',
}

export interface ProductItem {
  productId: string;
  amount: string;
}

export interface InternationalDrivingPermitFormType {
  product: ProductItem;
  pickupAtOffice?: boolean;
  membership?: ProductItem | null;
}

export interface HolderFormType {
  membershipSelection?: string;
  firstName: string;
  lastName: string;
  phoneNumber: PhoneNumberValue;
  eMail: string;
  gender: string;
  birthDate: {
    year: number;
    month: number;
    day: number;
  };
  cityOfBirth: string;
  countryOfBirth: string;
  city: string;
  address: string;
  zip: string;
  consents: MainMemberConsent[];
}
